import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface OpeningInventoryState {
  isLoading: boolean;
  isFinalizing: boolean;
  currentStep: number;
  setupComplete: boolean;
  accountingSetup: { ready: boolean; confirmed: boolean; manualLinking: boolean; missing: any[] };
  openingAccounts: any[];

  suppliersInventoryEditable: boolean;
  customersInventoryEditable: boolean;
  fixedAssetsInventoryEditable: boolean;
  accountsInventoryEditable: boolean;
  productsInventoryEditable: boolean;
  warehouseInventoryEditable: boolean;
  categoriesInventoryEditable: boolean;

  supplierList: any[];
  customerList: any[];
  fixedAssetList: any[];
  accountList: any[];
  productList: any[];
  fixedAssetsDepreciation: any[];

  categoriesList: any[];
  brandsList: any[];
  unitsList: any[];
  stockUnitsList: any[];
  warehousesList: any[];
  fixedAssetCategories: any[];
  fixedAssetLocations: any[];
}

export const initialState: OpeningInventoryState = {
  isLoading: false,
  isFinalizing: false,
  currentStep: 0,
  setupComplete: false,
  accountingSetup: { ready: false, confirmed: false, manualLinking: false, missing: [] },
  openingAccounts: [],

  suppliersInventoryEditable: true,
  customersInventoryEditable: true,
  fixedAssetsInventoryEditable: true,
  accountsInventoryEditable: true,
  productsInventoryEditable: true,
  warehouseInventoryEditable: true,
  categoriesInventoryEditable: true,

  supplierList: [],
  customerList: [],
  fixedAssetList: [],
  accountList: [],
  productList: [],
  fixedAssetsDepreciation: [],

  categoriesList: [],
  brandsList: [],
  unitsList: [],
  stockUnitsList: [],
  warehousesList: [],
  fixedAssetCategories: [],
  fixedAssetLocations: [],
};

export const openingInventorySlice = createSlice({
  name: 'openingInventory',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setFinalizing(state, action: PayloadAction<boolean>) {
      state.isFinalizing = action.payload;
    },
    setCurrentStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    setData(state, action: PayloadAction<Partial<OpeningInventoryState>>) {
      const payload = action.payload;
      // Guard: spreading null/undefined was a silent no-op, and returning a
      // fresh object from an immer reducer discarded the draft. Merge in place.
      if (!payload || typeof payload !== 'object') return;
      Object.assign(state, payload);
    }
  }
});

export const { setLoading, setFinalizing, setCurrentStep, setData } = openingInventorySlice.actions;

export default openingInventorySlice.reducer;
